import { observer } from 'mobx-react-lite';

import { useParams } from 'react-router';
import { head, orderBy } from 'lodash';
import styles from './index.module.scss';
import { eventNameOptions } from '../events-fields-options';
import classNames from 'classnames';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import EventMeta from '../EventMeta';
import AddClinicalEvent from '../Actions/AddClinicalEvent';
import useRtmEventsService from '../service';
import { formatTime } from '../../../../services/timeService';
import { dateTimeFormat } from '../../../../services/timeService/types';

const EventsList = ({
  uuid,
  onChange,
  sortType,
}: {
  uuid: string;
  onChange: (uuid: string) => void;
  sortType?: 'desc' | 'asc';
}) => {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { data } = useRtmEventsService(patientUuid);

  return (
    <div className={classNames('flex flex-col gap-4 p-4', styles.eventsList)}>
      <AddClinicalEvent />
      {orderBy(data, 'serviceTime', [sortType ?? 'desc'])?.map((event) => {
        const currentVersion = head(event.versions);
        const eventName = eventNameOptions?.find(
          (option) => option.value === currentVersion?.eventName,
        )?.label;

        return currentVersion ? (
          <div
            key={currentVersion.uuid}
            className={classNames('flex flex-col p-2', styles.event, {
              [styles.selected]: event.uuid === uuid,
            })}
            onClick={() => onChange(event.uuid)}
          >
            <div
              className={classNames(
                'flex justify-between text-neutrals-n-300 text-sm',
                styles.title,
              )}
            >
              {eventName} <KeyboardArrowRightIcon />
            </div>

            <EventMeta uuid={event.uuid} />
            <div
              className={'flex items-end flex-grow text-neutrals-n-300 text-xs'}
            >
              {formatTime(event.serviceTime, dateTimeFormat.DATE_TIME_FORMAT)}
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default observer(EventsList);
